export const DISPATCH_STATUS = {
  PENDING: 'pending',
  STARTED: 'started',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
};

export const DISPATCH_EXPIRY_DAYS = 30;
export const DISPATCH_CODE_LENGTH = 8;

/** When true, the app may queue SMS for conversation dispatches (Twilio-backed worker reads `messages`). */
export const TWILIO_SMS_ENABLED = process.env.REACT_APP_TWILIO_ENABLED === 'true';

const DEFAULT_DEMO_DISPATCH_BASE_URL = 'https://hlthdsk-experimental-demo.web.app/conversation';

// Keep base URL resolution inside this function for SSR/bulletproof-react safety.
// Do not read window at module import time.
export function getConversationDispatchBaseUrl() {
  const configured = process.env.REACT_APP_CONVERSATION_DISPATCH_BASE_URL;
  if (configured && configured.trim()) {
    return configured.trim().replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/conversation`;
  }

  return DEFAULT_DEMO_DISPATCH_BASE_URL;
}
